interface ICustomInput {
    className?: string;
    type: string;
    placeholder: string;
    disabled?: boolean;
    value?: string | number | undefined;
    name?: string;
    maxLength?: number;
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    onBlur?: React.FocusEventHandler<HTMLInputElement>
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
    onClick?: React.MouseEventHandler<HTMLInputElement>
    error?: boolean
    height?: number
    step?: number
    fontSize?: string
    min?: string | number
    max?: string | number
    readonly?: boolean
    autocompleteOff?: boolean
    isWhite?: boolean
}

const CustomInput = ({
    className,
    type,
    value,
    onChange,
    onClick,
    onBlur,
    onKeyDown,
    disabled = false,
    error = false,
    isWhite = false,
    placeholder,
    name,
    maxLength,
    height = 15,
    step,
    min,
    max,
    fontSize = 'lg',
    autocompleteOff = false,
    readonly = false
}: ICustomInput) => {
    return (
        <input
            className={`w-full h-${height} rounded-lg 
                ${type === 'file' && 'pt-1.5'} px-6 text-${fontSize} 
            placeholder:text-[#9D9EB7] placeholder:font-normal placeholder:text-${fontSize}
            disabled:bg-[#9D9EB7] disabled:cursor-not-allowed disabled:text-white
            hover:border-[#B3B3B3]
            ${isWhite ? 'bg-white' : 'bg-[#F8F8FA]'}
            border-1
            ${error ? 'border-red' : isWhite ? 'border-[#9D9EB7]' : 'border-transparent'}
            mobile:h-10 mobile:text-sm mobile:px-4 mobile:placeholder:text-sm
            ${className}`}
            placeholder={placeholder}
            disabled={disabled}
            type={type}
            value={value}
            onKeyDown={onKeyDown}
            onClick={(e) => {
                if (type === 'date' && !readonly) {
                    e.currentTarget.showPicker?.();
                }
                onClick?.(e)
            }}
            readOnly={readonly}
            // style={{ colorScheme: 'dark' }}
            onChange={onChange}
            onBlur={onBlur}
            {...(autocompleteOff ? { autoComplete: 'new-password' } : {})}
            {...(min ? { min: min } : {})}
            {...(max ? { max: max } : {})}
            {...(step ? { step: step } : {})}
            {...(name ? { name: name } : {})}
            {...(maxLength ? { maxLength: maxLength } : {})}
            {...(type === 'file' ? { accept: '.jpg, .jpeg, .pdf' } : {})}
        />
    );
}

export default CustomInput;